<template>
  <UserNameColumn :row="member.user" :row-index="rowIndex" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import UserNameColumn from '@/components/GraphqlDataTable/columns/User/UserNameColumn.vue'

const TeamMemberNameColumn = graphql(`
  fragment TeamMemberNameColumn on CompanyTeamMember {
    id
    user {
      id
      ...UserNameColumn
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof TeamMemberNameColumn>
  rowIndex?: number
}>()

const member = computed(() => useFragment(TeamMemberNameColumn, props.row))
</script>
